import { Plus, Trash, X } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { SearchSelect } from "@/components/SearchSelect";
import { ColorPicker, Num } from "./shared";

export const CutoutsTab = ({
  d,
  set,
  setCutout,
  opts,
  serviceOptions,
  productOptions,
}) => (
  <div className="mt-6 space-y-3" data-testid="drawing-cutouts">
    <p className="text-xs text-zinc-500">
      Default sizes used when a cut-out is dropped on the drawing. Link a product
      and a service to set pricing, and a color for the drawing.
    </p>
    <div className="grid gap-3 xl:grid-cols-2">
      {d.cutouts.map((c, i) => (
        <div
          key={c.kind || i}
          data-testid={`cutout-default-${i}`}
          className="rounded-lg border border-zinc-800 bg-zinc-900 p-3 transition-colors duration-150 hover:border-indigo-400/40"
        >
          <div className="flex flex-wrap items-center gap-2">
            <ColorPicker
              testId={`cutout-color-${i}`}
              value={c.color || opts.colors[0] || "#22d3ee"}
              options={opts.colors}
              onChange={(v) => setCutout(i, { color: v })}
            />
            <Input
              data-testid={`cutout-kind-${i}`}
              value={c.kind}
              onChange={(e) => setCutout(i, { kind: e.target.value })}
              placeholder="Cut-out name"
              className="h-10 min-w-[140px] flex-1 border-zinc-800 bg-zinc-950 text-sm font-semibold"
            />
            <Num
              testId={`cutout-w-${i}`}
              value={c.w_in}
              onChange={(v) => setCutout(i, { w_in: v })}
            />
            <span className="text-xs text-zinc-500">x</span>
            <Num
              testId={`cutout-h-${i}`}
              value={c.h_in}
              onChange={(v) => setCutout(i, { h_in: v })}
              suffix="in"
            />
            <button
              type="button"
              data-testid={`cutout-delete-${i}`}
              onClick={() =>
                set({ cutouts: d.cutouts.filter((_, idx) => idx !== i) })
              }
              className="rounded-lg border border-zinc-700 p-2 text-zinc-500 transition-colors duration-150 hover:border-red-500/40 hover:text-red-400"
            >
              <Trash size={14} weight="bold" />
            </button>
          </div>
          <div className="mt-2 flex flex-wrap items-center gap-2">
            <div className="min-w-[170px] flex-1">
              <SearchSelect
                testId={`cutout-product-${i}`}
                value={c.product_id || ""}
                options={productOptions}
                placeholder="Link a product (sink, etc.)"
                searchPlaceholder="Search products…"
                emptyText="Add sinks in Inventory"
                onChange={(v) => setCutout(i, { product_id: v })}
                className="h-10 px-3 text-xs"
              />
            </div>
            {c.product_id && (
              <button
                type="button"
                data-testid={`cutout-product-clear-${i}`}
                onClick={() => setCutout(i, { product_id: "" })}
                className="rounded-lg border border-zinc-700 p-2 text-zinc-500 transition-colors duration-150 hover:text-zinc-200"
              >
                <X size={14} weight="bold" />
              </button>
            )}
            <div className="min-w-[170px] flex-1">
              <SearchSelect
                testId={`cutout-service-${i}`}
                value={c.service_id || ""}
                options={serviceOptions}
                placeholder="Link a service (sets the price)"
                searchPlaceholder="Search services…"
                emptyText="Add services on the Services page"
                onChange={(v) => setCutout(i, { service_id: v })}
                className="h-10 px-3 text-xs"
              />
            </div>
            {c.service_id && (
              <button
                type="button"
                data-testid={`cutout-service-clear-${i}`}
                onClick={() => setCutout(i, { service_id: "" })}
                className="rounded-lg border border-zinc-700 p-2 text-zinc-500 transition-colors duration-150 hover:text-zinc-200"
              >
                <X size={14} weight="bold" />
              </button>
            )}
          </div>
        </div>
      ))}
      <button
        type="button"
        data-testid="add-cutout-default"
        onClick={() =>
          set({
            cutouts: [
              ...d.cutouts,
              {
                kind: "New cut-out",
                w_in: 12,
                h_in: 12,
                color: opts.colors[0] || "#22d3ee",
                product_id: "",
                service_id: "",
              },
            ],
          })
        }
        className="flex min-h-[104px] items-center justify-center gap-2 rounded-lg border border-dashed border-zinc-700 text-[11px] font-bold uppercase tracking-widest text-zinc-400 transition-colors duration-150 hover:border-indigo-400/60 hover:bg-zinc-900 hover:text-indigo-200"
      >
        <Plus size={16} weight="bold" /> Add cut-out
      </button>
    </div>
  </div>
);
